/**
 * d16n::legacy
 * d16n::source:<PCalculator.vue>
 * d16n::helpers-file
 */

export function getSubUnit(unit: string) {
  switch (unit) {
    case 'MG':
      return 'kg'
    case 'kg':
      return 'MG'
    default:
      return ''
  }
}
